export default __webpack_public_path__ + "static/media/SE-welcome-modal-map-1.2878519d.svg";